export default __webpack_public_path__ + "locales/si/DeleteThirdPartyDialog.json?hash=3fc018f085c7abd1b918595f3dfac37b";